export default {
  "name": "NCButtonApp",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCButtonApp",
  "label": "按钮组",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "tabindex": {
        "title": "tabindex",
        "description": "tabindex",
        "type": "number"
      },
      "tipKeybodard": {
        "title": "快捷键提示样式",
        "description": "快捷键提示样式",
        "type": "string"
      },
      "withAutoFocus": {
        "title": "自动聚焦",
        "description": "自动聚焦",
        "type": "boolean"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}